var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"content"}},[_c('toolbar-component',{on:{"clear-canvas":_vm.clearCanvas}}),_c('canvas-component',{ref:"canvasComponent"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }